export { VideoCommentary, calculateVideoCommentaryMetadata } from './VideoCommentary';
export type { VideoCommentaryProps, CommentItem } from './types';
export { videoCommentarySchema } from './types';
